import { rawColors } from './tokens';
import type { ThemePalette } from './types';

export const lightPalette: ThemePalette = {
  primary: rawColors.blue500,
  primaryLight: rawColors.blue100,
  primaryDark: rawColors.blue800,
  primaryBg: rawColors.blue50,
  onPrimary: rawColors.white,

  background: rawColors.white,
  bgSecondary: rawColors.gray50,
  bgTertiary: rawColors.gray100,
  surface: rawColors.white,

  textPrimary: rawColors.gray900,
  textSecondary: rawColors.gray700,
  textMuted: rawColors.gray500,
  textDisabled: rawColors.gray400,
  textOnPrimary: rawColors.white,

  border: rawColors.gray200,
  borderMedium: rawColors.gray300,
  borderLight: rawColors.gray100,

  // Semantic
  error: rawColors.red600,
  errorBg: rawColors.red50,
  errorBorder: rawColors.red200,
  errorText: rawColors.red800,
  warning: rawColors.amber500,
  warningBg: rawColors.amber50,
  warningBorder: rawColors.amber200,
  warningText: rawColors.amber800,
  success: rawColors.green500,
  successBg: rawColors.green50,
  successBorder: rawColors.green200,
  successText: rawColors.green800,
  info: rawColors.sky50,
  infoBorder: rawColors.sky200,
  infoText: rawColors.sky700,

  // AI / purple
  ai: rawColors.purple500,
  aiBg: rawColors.purple100,
  aiBorder: rawColors.purple300,
  aiText: rawColors.purple600,
  aiCardBg: rawColors.purple50,
  aiCardBorder: rawColors.purple200,

  // Score
  excellent: rawColors.green600,
  good: rawColors.blue500,
  average: rawColors.amber500,
  poor: rawColors.red500,

  // Activity status
  todo: { bg: rawColors.blue100, text: rawColors.blue800 },
  'in-progress': { bg: rawColors.amber100, text: rawColors.amber800 },
  done: { bg: '#d1fae5', text: rawColors.green800 },
  skipped: { bg: rawColors.gray100, text: rawColors.gray500 },

  // Goal status
  planned: { bg: rawColors.indigo100, text: rawColors.indigo800 },
  active: { bg: rawColors.blue100, text: rawColors.blue800 },
  completed: { bg: '#d1fae5', text: rawColors.green800 },
  paused: { bg: rawColors.amber100, text: rawColors.amber800 },

  // Entity type
  activity: { bg: rawColors.blue100, text: rawColors.blue700 },
  goal: { bg: rawColors.green100, text: '#15803d' },
  vision: { bg: '#f3e8ff', text: '#7e22ce' },

  // Misc
  overlay: 'rgba(0, 0, 0, 0.4)',
  highlightBg: rawColors.yellow200,
  placeholder: rawColors.gray400,
  brandedBackground: rawColors.blue500,
  danger: rawColors.red600,
  dangerText: rawColors.red800,
};

export const darkPalette: ThemePalette = {
  primary: rawColors.blue500,
  primaryLight: '#1e3a5f',
  primaryDark: rawColors.blue300,
  primaryBg: '#172554',
  onPrimary: rawColors.white,

  background: rawColors.gray950,
  bgSecondary: rawColors.gray900,
  bgTertiary: rawColors.gray800,
  surface: rawColors.gray900,

  textPrimary: rawColors.gray50,
  textSecondary: rawColors.gray300,
  textMuted: rawColors.gray400,
  textDisabled: rawColors.gray600,
  textOnPrimary: rawColors.white,

  border: rawColors.gray700,
  borderMedium: rawColors.gray600,
  borderLight: rawColors.gray800,

  // Semantic
  error: rawColors.red500,
  errorBg: '#2d1313',
  errorBorder: '#5c2020',
  errorText: rawColors.red200,
  warning: rawColors.amber400,
  warningBg: '#2d2305',
  warningBorder: '#5c4a0e',
  warningText: rawColors.amber200,
  success: rawColors.green400,
  successBg: '#0d2818',
  successBorder: '#1a5c2e',
  successText: rawColors.green200,
  info: '#0c2d48',
  infoBorder: '#1a4a6e',
  infoText: rawColors.sky200,

  // AI / purple
  ai: rawColors.purple400,
  aiBg: '#1a1028',
  aiBorder: '#3d2a5c',
  aiText: rawColors.purple300,
  aiCardBg: '#1a1028',
  aiCardBorder: '#3d2a5c',

  // Score
  excellent: rawColors.green400,
  good: rawColors.blue300,
  average: rawColors.amber400,
  poor: rawColors.red400,

  // Activity status
  todo: { bg: '#172554', text: rawColors.blue300 },
  'in-progress': { bg: '#2d2305', text: rawColors.amber200 },
  done: { bg: '#0d2818', text: rawColors.green200 },
  skipped: { bg: rawColors.gray800, text: rawColors.gray400 },

  // Goal status
  planned: { bg: '#1e1b4b', text: '#a5b4fc' },
  active: { bg: '#172554', text: rawColors.blue300 },
  completed: { bg: '#0d2818', text: rawColors.green200 },
  paused: { bg: '#2d2305', text: rawColors.amber200 },

  // Entity type
  activity: { bg: '#172554', text: rawColors.blue300 },
  goal: { bg: '#0d2818', text: rawColors.green200 },
  vision: { bg: '#1a1028', text: rawColors.purple300 },

  // Misc
  overlay: 'rgba(0, 0, 0, 0.6)',
  highlightBg: '#3d3800',
  placeholder: rawColors.gray600,
  brandedBackground: rawColors.blue500,
  danger: rawColors.red500,
  dangerText: rawColors.red200,
};
